'use client'

import { useEffect, useRef } from 'react'

export function VideoBackground({ src }: { src: string }) {
  const ref = useRef<HTMLVideoElement>(null)

  useEffect(() => {
    const video = ref.current
    if (!video)
      return

    const restart = () => {
      video.currentTime = 0
      video.play().catch(() => {})
    }

    video.addEventListener('ended', restart)
    return () => video.removeEventListener('ended', restart)
  }, [])

  return (
    <video
      ref={ref}
      className="absolute inset-0 h-full w-full object-cover"
      autoPlay
      muted
      loop
      playsInline
    >
      <source src={src} type="video/mp4" />
    </video>
  )
}
